import { CoverSongOptionsEnum } from '../../enums/CoverSongOptionsEnum.es.js';

class ReleaseArtist {
    constructor() {
        this.name = null;
        this.id = null;
    }
}
class ReleaseArtistV2 {
    constructor() {
        this.name = null;
        this.id = null;
        this.order = null;
    }
}
class ReleaseSongwriter extends ReleaseArtist {
    constructor() {
        super(...arguments);
        this.publisherName = null;
    }
}
class ReleaseLyricist extends ReleaseArtist {
    constructor() {
        super(...arguments);
        this.publisherName = null;
    }
}
class ReleaseContributor {
    constructor() {
        this.role = null;
        this.artists = [];
    }
}
class ReleasePublisher extends ReleaseArtist {
    constructor() {
        super(...arguments);
        this.email = null;
        this.publishingHouse = null;
    }
}
class Release {
    constructor(id, name, creationTime) {
        this.id = id;
        this.name = name;
        this.creationTime = creationTime;
        this.additionalArtists = [];
        this.autoGenerateLabel = true;
        this.autoGenerateUpcCode = true;
        this.catalogNumber = null;
        this.compositionOwner = null;
        this.compositionYear = null;
        this.countries = [];
        this.excludeCountries = false;
        this.globalState = null;
        this.hasBeenDelivered = false; // if the release was already delivered to Fuga in the past
        this.hasCoverArt = false;
        this.hasCoverSong = false;
        this.hasOriginalReleaseDate = false;
        this.label = null;
        this.language = null;
        this.lastUpdateTime = null;
        this.mainGenre = null;
        this.mainSubGenre = null;
        this.masterRecordingOwner = null;
        this.masterRecordingYear = null;
        this.originalReleaseDate = null;
        this.parentalAdvisory = false; // deprecated in favor of parentalWarning
        this.parentalWarning = null;
        this.primaryArtists = [];
        this.releaseDate = null;
        this.releaseFormat = null;
        this.releaseTargetDate = null;
        this.restrictCountries = false;
        this.serviceProviders = [];
        this.signedToken = null;
        this.state = null;
        this.monetizationEligibilityState = null;
        this.supplier = null;
        this.tracks = [];
        this.upcCode = null;
        this.userId = null;
        this.version = null;
    }
}
const keysOfRelease = ["additionalArtists", "autoGenerateLabel", "autoGenerateUpcCode", "catalogNumber", "compositionOwner", "compositionYear", "countries", "errors", "excludeCountries", "globalState", "hasBeenDelivered", "hasCoverArt", "hasCoverSong", "hasOriginalReleaseDate", "label", "language", "lastUpdateTime", "mainGenre", "mainSubGenre", "masterRecordingOwner", "masterRecordingYear", "originalReleaseDate", "parentalAdvisory", "parentalWarning", "primaryArtists", "releaseDate", "releaseFormat", "releaseTargetDate", "restrictCountries", "serviceProviders", "signedToken", "state", "monetizationEligibilityState", "supplier", "tracks", "upcCode", "userId", "version", "id", "name", "creationTime"];
class ReleaseTrack {
    constructor(id, name) {
        this.id = id;
        this.name = name;
        /** If present, the track is present in another release (for more info check ReusedTrackInfos ) */
        this.reusedTrack = null;
        this.genre = null;
        this.subGenre = null;
        this.previewStart = 0;
        this.previewLength = 30;
        this.primaryArtists = [];
        this.additionalArtists = [];
        this.publishers = [];
        this.producers = [];
        this.contributors = [];
        this.remixers = [];
        this.autoGenerateIsrcCode = true;
        this.isrcCode = null;
        this.parentalAdvisory = false; // deprecated in favor of parentalWarning
        this.parentalWarning = null;
        this.availableSeparately = true;
        this.language = null;
        this.metadata = null;
        this.isCoverSong = false; // deprecated in favor of coverSongOptions
        this.coverInfos = {
            originalTrackTitle: null,
            originalArtistsNames: [],
            originalSongwriters: [],
            originalTrackLink: null,
        };
        this.coverSongOptions = CoverSongOptionsEnum.OriginalComposition;
        this.songwriters = [];
        this.lyricists = [];
        this.hasLyrics = null;
        this.lyricsLanguage = null;
        this.version = null;
    }
}
/**
 * When a track is already reused somewhere (any release, even in drafts)
 * https://www.notion.so/landr/ISRC-Reuse-Prequel-Allow-reuse-Track-information-even-If-the-track-is-not-yet-released-e5f2667f05bc4ad6b77006fb8063a105
 */
class ReusedTrackInfos {
    constructor() {
        this.releaseId = null;
        this.unlockedFields = [];
        this.upcCode = null;
        // The Frontend do not need this field but due to DIS-6776 we have to return it to the backend on save
        // without this the backend will allow frontend to save all info he wants on ISRC Reused tracks (DIS-9011).
        this.state = null;
        /**
         * Inform if one release containing this track was already submitted or is already live,
         * and therefore we should avoid manipulation with the only exception of fields provided in `unlockedFields`
         */
        this.submittedOrReleased = null;
    }
}
/**
 * State of an specific Service Provider (DSP)
 */
class ReleaseServiceProviderState {
    constructor() {
        this.name = null;
        this.category = null;
        this.state = null;
    }
}
class ReleaseTrackCoverInfos {
    constructor() {
        this.originalTrackTitle = null;
        this.originalArtistsNames = [];
        this.originalSongwriters = [];
        this.originalTrackLink = null;
    }
}
class ReleaseStore {
    constructor(name = null, usersCount = 0, hasLogo = false) {
        this.name = name;
        this.usersCount = usersCount;
        this.hasLogo = hasLogo;
        this.isAvailable = true;
        this.category = null;
        this.error = null;
    }
}
class ReleaseError {
    constructor(code, message) {
        this.code = code;
        this.message = message;
    }
}
class ReleaseTrend {
    constructor(value, count) {
        this.value = value;
        this.count = count;
    }
}
class ReleaseTrendsDailyTotal {
    constructor() {
        this.date = null;
        this.downloads = null;
        this.streams = null;
    }
}

export { Release, ReleaseArtist, ReleaseArtistV2, ReleaseContributor, ReleaseError, ReleaseLyricist, ReleasePublisher, ReleaseServiceProviderState, ReleaseSongwriter, ReleaseStore, ReleaseTrack, ReleaseTrackCoverInfos, ReleaseTrend, ReleaseTrendsDailyTotal, ReusedTrackInfos, keysOfRelease };
